import React from 'react';
import {
    AiOutlineShoppingCart,
} from "react-icons/ai";

export default function Product({ product }) {
    return (
        <div className='relative shadow-none w-full'>
            <div className="absolute top-3 right-3 cursor-pointer z-48  p-2 hover:scale-110 bg-white transition-all rounded-full">
                <AiOutlineShoppingCart />
            </div>
            <div key={product.id} class="shadow rounded-lg ">
                <img src={product.image} alt={product.name} class="w-full h-48 sm:h-[330px] object-cover rounded " />
                <div class="p-4">
                    <h3 class="text-sm font-semibold">{product.name}</h3>
                    {/* <p class="text-sm text-gray-600">Description of product 1.</p> */}
                    <p class="font-bold text-sm">{product.price}</p>
                </div>
            </div>
        </div>
    )
}
